const styles = {
  wrapperSx: {
    mt: { xs: 6, md: 10 },
  },

  cardSx: {
    borderRadius: { xs: "10px", sm: "12px" },
    overflow: "hidden",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "0 8px 48px rgba(0,0,0,0.6)",
    bgcolor: "#0a0a0a",
    maxWidth: 1100,
    mx: "auto",
  },

  playerBoxSx: {
    aspectRatio: "16/9",
    bgcolor: "#000",
  },

  iframeStyle: {
    width: "100%",
    height: "100%",
    border: "none",
    display: "block",
  },

  navRowSx: (hasMultiple) => ({
    px: { xs: 1.5, sm: 2 },
    py: 1.25,
    display: "flex",
    alignItems: "center",
    gap: 1,
    borderBottom: hasMultiple ? "1px solid rgba(255,255,255,0.07)" : "none",
  }),

  navTitleSx: {
    flex: 1,
    color: "rgba(255,255,255,0.75)",
    fontSize: { xs: "0.82rem", sm: "0.88rem" },
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minHeight: "1.2em",
  },

  navControlsSx: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },

  navBtnSx: {
    color: "rgba(255,255,255,0.25)",
    p: "4px",
    "&:hover": { color: "rgba(255,255,255,0.7)", bgcolor: "rgba(255,255,255,0.06)" },
  },

  navIconSx: { fontSize: "18px" },

  counterSx: {
    color: "rgba(255,255,255,0.18)",
    fontSize: "0.6rem",
    minWidth: 28,
    textAlign: "center",
    letterSpacing: "0.04em",
  },

  // ── PlaylistRow ──

  rowSx: (isActive) => ({
    position: "relative",
    display: "flex",
    alignItems: "center",
    px: 1.5,
    py: 0.85,
    gap: 1.5,
    cursor: "pointer",
    bgcolor: isActive ? "rgba(255,255,255,0.055)" : "transparent",
    transition: "background 0.15s",
    "&:hover": {
      bgcolor: isActive ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.028)",
    },
    "&:not(:last-child)": {
      borderBottom: "1px solid rgba(255,255,255,0.04)",
    },
  }),

  accentBarSx: (isActive) => ({
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: "3px",
    borderRadius: "0 2px 2px 0",
    bgcolor: isActive ? "rgba(255,255,255,0.7)" : "transparent",
    transition: "background 0.2s",
  }),

  rowIndexBoxSx: {
    width: 20,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  rowPlayIconSx: { fontSize: "14px", color: "rgba(255,255,255,0.75)" },

  rowIndexSx: {
    fontSize: "0.6rem",
    color: "rgba(255,255,255,0.2)",
    fontVariantNumeric: "tabular-nums",
    lineHeight: 1,
  },

  rowThumbBoxSx: (isActive) => ({
    position: "relative",
    flexShrink: 0,
    width: { xs: 80, sm: 96 },
    borderRadius: "6px",
    overflow: "hidden",
    aspectRatio: "16/9",
    boxShadow: isActive ? "0 2px 12px rgba(0,0,0,0.5)" : "none",
    transition: "box-shadow 0.2s",
  }),

  rowThumbImgSx: (isActive) => ({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    filter: isActive ? "none" : "brightness(0.55)",
    transition: "filter 0.2s",
  }),

  rowThumbOverlaySx: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  rowThumbPlayIconSx: { color: "rgba(255,255,255,0.55)", fontSize: "13px" },

  rowTitleSx: (isActive) => ({
    flex: 1,
    color: isActive ? "rgba(255,255,255,0.92)" : "rgba(255,255,255,0.42)",
    fontSize: { xs: "0.78rem", sm: "0.82rem" },
    fontWeight: isActive ? 600 : 400,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    lineHeight: 1.45,
    transition: "color 0.15s",
  }),
};

export default styles;
